export default "__VITE_ASSET__CcXS0A23__"